/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useEnvStore } from '../env';
import { useAppClientStore } from '.';

/*
 * This hook will launch authenticated requests  
 * It ensures token is available 
 * 
 */

function useAppClient (p) {
    const env = useEnvStore();
    const appClient = useAppClientStore();
 
    useEffect(() => {
       console.log(' Env Store ', env.version);
       console.log(' Store ', appClient.version);
       
    }, []);
 
    function closeWidget () {
        env.appStore.oauthSessionId = null;
        appClient.closeWidget();
    }
    
    return {
        closeWidget,
    };
}

export default useAppClient;